import React from 'react';
import Select from 'react-select';
import { ErrorMessage } from 'formik';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify'

import {
  Row,
  Col,
  Label,
  Input,
  FormGroup,
  Button

} from 'reactstrap';

import ImageWidget from './ImageWidget'

const AddDoucment = (props) => {
  
  const handleFileUpload = (event) => {
    let currentFiles = event.target.files;
    if(currentFiles.length > 4) {
      toast.error("Maximum of 4 files can be uploaded");
      return;
    }
    const types = ['image/png',  'image/jpeg', 'application/pdf']
    for(let file of currentFiles) {
      if(types.every(type => file.type !== type)) {
        toast.error(`${file.type} is not a supported format`);
        return;
      }
    }
    let files = [];
    for(let file of currentFiles) {
      files.push({filename: file.name, uploaded: false});
    }
    props.setFieldValue("files", [...props.uploadedFiles, ...files])
    props.setFieldValue(`document.files`, currentFiles);
  }

  return (
    <React.Fragment>
      <Row>
        Document Details
      </Row>
      <hr />
      <Row>
        <Col xs="12" md="4">
          <Label>
            Type of Documents
          </Label>
          {props.type !== 2 ? 
            <Select name={`document.documentType`} 
              value={props.documentType}
              options={props.documentsOption}
              onChange={(selectedOption) => props.setFieldValue(`document.documentType`, props.category)}
              isDisabled
            /> : 
            <Select name={`document.documentType`}
              defaultValue={props.documentType}
              options={props.documentsOption}
              onChange={(selectedOption) => props.setFieldValue(`document.documentType`, selectedOption['value'])}
            />
          }
        </Col>
        <Col xs="12" md="4">
          <Label>
            Title of Documents
          </Label>
          <Input type="text"
            name={`document.title`}
            value={props.title}
            onChange={props.handleChange}
          />
          <ErrorMessage name="document.title">{msg => <div id="feedback" className="text-danger">{msg}</div>}</ErrorMessage>
          {/* {props.errors.document.title && props.touched.document.title && <div id="feedback" className="text-danger">{props.errors.document.title}</div>} */}
        </Col>
        <Col xs="12" md="4">
          <FormGroup>
            <Label>Description</Label>
            <Input type="textarea" rows="5"
              name={`document.description`}
              value={props.description} 
              onChange={props.handleChange}
            />
          <ErrorMessage name="document.description">{msg => <div id="feedback" className="text-danger">{msg}</div>}</ErrorMessage>
          {/* {props.errors.document.description && props.touched.document.description && <div id="feedback" className="text-danger">{props.errors.document.description}</div>} */}
          </FormGroup>
        </Col>
        <Col xs="12" md="4">
          <FormGroup>
            <Label className="w-100">Upload Documents</Label>
            <Button onClick={() => this.fileInput.click()}>Upload files</Button>
            <input className="d-none"  
              type="file" 
              key={props.fileInputKey}
              name={`document.files`}
              // value={props.file}
              onChange={handleFileUpload}
              // onChange={(event) => {
              //   let files = [];
              //   for(let file of event.target.files) {
              //     files.push({filename: file.name, uploaded: false})
              //   }
              //   props.setFieldValue("files", [...props.uploadedFiles, ...files])
              //   props.setFieldValue(`document.files`, event.currentTarget.files);
              // }}
              ref={fileInput => this.fileInput = fileInput}
              multiple />
              <p className="text-muted">*Formats JPEG, PNG, PDF only.<br />
              Maximum 4 files are allowed</p>
              <ImageWidget files={props.files} formType={props.formType} deleteImage={props.deleteImage}/>
          </FormGroup>
        </Col>
        <Col xs="12" md="4">
          <FormGroup>
            <Label for="lastLMP">
              Date of Appointment/Test
            </Label>
            {/* <DatePicker 
              value={props.appointment}
              onChange={(date) => props.setFieldValue("document.appointment", date)}
            /> */}
            {/* <SingleDatePicker 
              date={props.appointment}
              onDateChange={date => props.setFieldValue("document.appointment", date)}
              numberOfMonths={1}
              focused={props.calendarFocussed}
              onFocusChange={({ focused }) => { props.setStaus()}}
            /> */}
            {/* <DateTime 
              value={props.appointment}
              onChange={props.handleChange}
              timeFormat={false}
              open={false}
              closeOnSelect={true}
            /> */}

            <DatePicker name="document.appointment"
              selected={props.appointment} 
              onChange={date => props.setFieldValue("document.appointment", date)}
              maxDate={new Date()}
            />
            {/* <Input type="date" 
              name={`document.appointment`} 
              value={props.appointment}
              onChange={props.handleChange}
            /> */}
          <ErrorMessage name="document.appointment">{msg => <div id="feedback" className="text-danger">{msg}</div>}</ErrorMessage>
          </FormGroup>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default AddDoucment;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/AddDocument.js